import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { getWorklogHistory } from "../../../services/apiWorklog";
import { addAllBoard, setWorkHours } from "../../../redux/SearchSlice";
import { setAllGroupUser } from "../../../redux/TaskGroupingSlice";
import {
  filterWorklogsBySearchText,
  getFlattenedGroupingUsers,
  getTotalWorklogHours,
  parseBoardIdsParam,
  parseUserIdsParam,
} from "../utils/myTaskUtils";
import { useResponsive } from "../../../hooks/useResponsive";

export function useWorklogHistoryState() {
  const [worklogs, setWorklogs] = useState([]);
  const [totalWorklogs, setTotalWorklogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("users");
  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const boardList = useSelector((state) => state.search.boardSearch);
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("uid");
  const boardParam = searchParams.get("board");
  const dateRange = useSelector((state) => state.search.dateRange);
  const epicSearch = useSelector((state) => state.search.epicSearch);
  const searchText = useSelector((state) => state.search.searchText);

  const user = useMemo(
    () =>
      isMobile ? parseUserIdsParam(userParam) : getFlattenedGroupingUsers(groupingUser),
    [groupingUser, isMobile, userParam]
  );

  const checkedList = useMemo(
    () => (isMobile ? parseBoardIdsParam(boardParam) : boardList),
    [boardList, boardParam, isMobile]
  );

  useEffect(() => {
    let isMounted = true;

    setLoading(true);
    getWorklogHistory(user, checkedList, dateRange, epicSearch)
      .then((response) => {
        if (!isMounted) {
          return;
        }

        const responseData = response?.data?.data?.responseData || [];
        setTotalWorklogs(responseData);
        setWorklogs(responseData);
        setLoading(false);
        dispatch(setWorkHours(getTotalWorklogHours(responseData)));
      })
      .catch((error) => {
        if (!isMounted) {
          return;
        }

        if (error.code !== "ERR_CANCELED") {
          setLoading(false);
        }
        setWorklogs([]);
        setTotalWorklogs([]);
      });

    return () => {
      isMounted = false;
    };
  }, [checkedList, dateRange, dispatch, epicSearch, user]);

  const filteredWorklogs = useMemo(
    () => filterWorklogsBySearchText(totalWorklogs, searchText),
    [searchText, totalWorklogs]
  );

  useEffect(() => {
    setWorklogs(filteredWorklogs);
  }, [filteredWorklogs]);

  useEffect(() => {
    return () => {
      dispatch(addAllBoard([]));
      dispatch(setAllGroupUser([]));
    };
  }, [dispatch]);

  return {
    currentTab,
    loading,
    setCurrentTab,
    totalWorklogs,
    worklogs,
  };
}
